import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorSearchboxSearchBarModule } from '../searchbox-search-bar/searchbox-search-bar.module';
import { SdCustomSearchBoxComponent } from './custom-search-box.component';

@NgModule({
  imports: [AsyncPipe, SdvorSearchboxSearchBarModule],
  declarations: [SdCustomSearchBoxComponent],
  exports: [SdCustomSearchBoxComponent],
})
export class SdvorCustomSearchBoxModule {}
